var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useEffect } from "react";
import { Snackbar, Box, Paper, makeStyles } from "@material-ui/core";
import { CloseIcon, SuccessIcon, ErrorIcon } from "../icons";
import { FTLTypography } from "../FTLTypography";
import classNames from "classnames";
export const FTLSnackbar = (_a) => {
    var { open, message, hideDuration = 3000, onClose, IconComponent, variant, className } = _a, otherProps = __rest(_a, ["open", "message", "hideDuration", "onClose", "IconComponent", "variant", "className"]);
    const classes = useStyles();
    const [isOpen, setIsOpen] = useState(open);
    useEffect(() => {
        setIsOpen(open);
    }, [open]);
    return (React.createElement(Snackbar, Object.assign({ open: isOpen, autoHideDuration: hideDuration, className: classNames(className, classes.root), onClose: () => {
            setIsOpen(false);
            if (onClose) {
                onClose();
            }
        }, anchorOrigin: {
            horizontal: "center",
            vertical: "bottom",
        } }, otherProps),
        React.createElement(Box, { className: classes.body, component: Paper },
            variant === "error" ? (React.createElement(ErrorIcon, { style: { marginRight: 14 } })) : variant === "success" ? (React.createElement(SuccessIcon, { style: { marginRight: 14 } })) : (IconComponent && React.createElement(IconComponent, { style: { marginRight: 14 } })),
            React.createElement(FTLTypography, { variant: "p3", style: {
                    padding: "2px 0",
                } }, message),
            React.createElement(CloseIcon, { className: classes.closeIcon, color: "secondary", sizeRatio: 1.25, onClick: () => {
                    setIsOpen(false);
                    if (onClose) {
                        onClose();
                    }
                } }))));
};
const useStyles = makeStyles({
    root: {
        bottom: 40,
        zIndex: 1320,
        left: 0,
        right: 0,
    },
    body: {
        position: "relative",
        padding: "8px 10px",
        display: "flex",
        justifyContent: "space-between",
        minWidth: 245,
        boxShadow: "0px 16px 16px rgba(0, 0, 0, 0.12), 0px 0px 8px rgba(0, 0, 0, 0.08)",
    },
    closeIcon: {
        cursor: "pointer",
        margin: 2,
        marginLeft: 14,
    },
});
//# sourceMappingURL=index.js.map